import gql from 'graphql-tag';

export const GRAPHQL_APPLICATION_QUERY = gql`
  query Application($applicationId: ID!) {
    application(applicationId: $applicationId) {
      id
      guarantorMmi
      guarantor {
        id
        firstName
        lastName
      }
      status
      detailedStatus
      createDate
      updateDate
      adjustAmount
      totalConsideredAmount
      encounters {
        id
        location {
          id
        }
        accountNumber
        patient {
          id
          firstName
          lastName
        }
        admitDate
        billingDescription
        dischargeDate
      }
    }
  }
`;
